<template>
    <v-row
        class="prod-review-list-item"
        density="compact"
    >
        <v-col
            cols="3"
            sm="2" class="text-end text-md-start order-2 order-md-1"
        >
            <div
                 class="pt-1 font-weight-medium font-size-7"
            >
                {{ review.author }}
            </div>
            <div
                v-if="date"
                 class="mt-n1 font-size-8"
            >
                {{ date }}
            </div>
        </v-col>
        <v-col
            class="order-1 order-md-2"
        >
            <StarRating
                :rating="review.rating"
                :increment="0.1"
                :show-rating="false"
                :star-size="10"
                :gap="4"
                :rounded-corners="true"
                active-color="#333"
                border-color="#333"
                inactive-color="#fff"
                :border-width="2"
                readonly
            ></StarRating>

            <h4
                class="py-0 mb-0 mt-1"
            >
                {{ review.title }}
            </h4>
            <template
                v-if="!isMobile"
            >
                <div
                    class="mt-4 d-none d-md-block"
                >
                    {{ review.content }}
                </div>
                <div
                    v-if="review.response"
                    class="mt-4"
                >
                    <v-divider
                        class="my-3"
                    ></v-divider>
                    <div
                        class="font-weight-medium"
                    >
                        Reply from {{ replyName }}
                    </div>
                    {{ review.response }}
                </div>
            </template>
        </v-col>
        <v-col
            class="order-3"
            v-if="isMobile"
            cols="12"
        >
            {{ review.content }}

            <div
                v-if="review.response"
                class="mt-4"
            >
                <v-divider
                    class="my-3 w-25"
                ></v-divider>
                <div
                    class="font-weight-medium"
                >
                    Reply from {{ replyName }}
                </div>
                {{ review.response }}
            </div>
        </v-col>
    </v-row>
</template>

<script lang="ts" setup>
    import type {
        Review
    } from '~/types';
    import { fmtDate, displayDateFormat } from 'x1-base/utils';
    import { useIsMobile } from '~/composables';
    import StarRating from 'x1-base/components/star-rating/StarRating/StarRating.vue';

    const props = defineProps<{
        review: Review;
        replyName: string;
    }>();

    const { isMobile } = useIsMobile();
    const date = ref<Nullable<string>>('');

    try {
        let d: string = '';

        if (props.review?.date?.length) {
            const dateVal = props.review.date;
            d = (dateVal.length <= 10) ? `${dateVal}T00:00:00.000-07:00` : dateVal;
        } else if (props.review?.createdAt) {
            d = props.review.createdAt;
        }

        date.value = d ? fmtDate(d, displayDateFormat) : null;
    } catch (error) {
        date.value = null;
    }
</script>

<style lang="scss"></style>
